/**
 * Turns the local Iraqi format returned by the API into the international one.
 * Only the first "0" is replaced (same as the original behaviour).
 */
export const toInternationalPhone = (phone) => phone.replace("0", "+964");
